<template>
  <div class="store-list-page" :class = "{'clear-header':isWechatBrowser}">
    <my-header title="主材卖场" v-if="!isWechatBrowser" :showBack="true"></my-header>
    <div class="store-list">
      <div v-if="storeList.length!=0" v-for="store in storeList" class="store-item general-box-shadow" @click="toStoreShopList(store.id,store.name)">
        <img class="store-img" :src="imgUrl + store.image | ossProcess(330, 330)">
        <div class="store-name">{{store.name}}</div>
      </div>
      <div class="black-page" v-if="storeList.length==0">
        <img src="../../assets/icon-no-img.png">
        <div class="tip">暂无相关卖场</div>
      </div>
    </div>
  </div>
</template>

<script>
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import {imgUrl,shareIcon} from "../../config";
  import shareService from '../../service/share/ShareService'
  import storeService from '../../service/store/StoreService'

  export default {
    name: 'StoreList',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        imgUrl: imgUrl,
        shareIcon:shareIcon,
        pageNo:1,
        storeList:[],
        isWechatBrowser:this.$verfyBrowserType()
      }
    },

    beforeMount () {
      document.title = this.$route.meta.title;
      this.getStoreList();
      this.initWechatShare();
    },
    methods: {
      async getStoreList(){
        if(this.pageNo == 1){
          this.storeList = [];
        }
        let {code,msg,data} = await storeService.list(this.pageNo);
        if(code == '0'){
          this.storeList = data;
          for (let store of this.storeList){
            if(store.name != null && store.name.length >8 ){
              store.name = store.name.substring(0,8)+'..'
            }
          }
        }else {
          Toast(msg);
        }
      },
      toStoreShopList(storeId,storeName){
        this.$router.push({name: 'StoreShopList', query: {storeId,storeName}})
      },
      async initWechatShare(){
        let title = "水木家居商城主材市场";// 分享标题
        let desc = "家居大牌，强强合作，买的安心，用着放心"; // 分享描述
        let link = window.location.href; // 分享链接
        link = link.replace(/#/, '?#');
        await shareService.wechatShare(title,desc,link,this.shareIcon);
      },
    }
  }
</script>
<style lang="scss">
  @import '../../assets/style/common.scss';
  .store-list-page {
    background: white;
    padding-bottom: 0.2rem;
    font-size: 0.32rem;
    .store-list{
      display: flex;
      flex-flow: row wrap;
      .store-item{
        width: 3.3rem;
        height: 4.1rem;
        margin-top: 0.3rem;
        margin-left: 0.3rem;
        .store-name{
          line-height: 0.8rem;
          padding-left: 0.2rem;
          font-weight: bold;
        }
        .store-img{
          width: 3.3rem;
          height: 3.3rem;
          display: block;
          border-radius: 0.08rem 0.08rem 0px 0px;
        }
      }
    }
  }
</style>
